export function extractDatabricksInstanceId(url: string): string | null {
  try {
    let urlObj: URL;

    // Check if the input already has a protocol
    if (url.startsWith('http://') || url.startsWith('https://')) {
      urlObj = new URL(url);
    } else {
      // If no protocol, prepend https://
      urlObj = new URL(`https://${url}`);
    }

    const hostname = urlObj.hostname;

    // Check if it's a Databricks URL
    if (
      hostname.endsWith('.azuredatabricks.net') ||
      hostname.endsWith('.cloud.databricks.com') ||
      hostname.endsWith('.gcp.databricks.com')
    ) {
      return hostname;
    }

    return null;
  } catch {
    // Return null for invalid URLs
    return null;
  }
}
